export default __webpack_public_path__ + "static/media/ArdashirArenaMap.f18d1040.jpg";